import React from "react";
import ParagraphTag from "../reusebale/Paragraph";
import ButtonTag from "../reusebale/button";
import { X, AlertTriangle } from "lucide-react";
import MyLoader from "../reusebale/myLoader";

const RetryTransactionPopUp = ({ transaction, onConfirm, onClose, loading }) => {
  const formatCurrency = (amount) => {
    if (!amount) return "$0.00";
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  };

  const getMonthLabel = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", { month: "long", year: "numeric" });
  };

  const retryAmount = (transaction?.amount || 0) - (transaction?.security_deposit || 0);

  return (
    <main className="w-full h-screen backdrop-blur-sm bg-black/80 fixed inset-0 z-50 flex items-center justify-center">
      <section className="w-[90%] sm:w-[65%] md:w-[50%] lg:w-[40%] xl:w-[25%] bg-white shadow rounded-[31px] mx-auto p-6">
        <div className="flex justify-between items-center mb-4">
          <ParagraphTag
            content="Retry Payment"
            classes="text-darkColor font-popinsSemiBold text-base"
          />
          <button onClick={onClose}>
            <X size={20} />
          </button>
        </div>

        <div className="flex items-center gap-2 bg-amber-50 border border-amber-200 rounded-lg p-3 mb-4">
          <AlertTriangle className="w-5 h-5 text-amber-500 flex-shrink-0" />
          <ParagraphTag
            content="Are you sure you want to retry this failed transaction?"
            classes="text-amber-800 font-popinsMedium text-sm"
          />
        </div>

        <div className="space-y-2 mb-6">
          <div className="flex justify-between">
            <ParagraphTag
              content="Amount"
              classes="text-darkColor/60 font-popinsMedium text-sm"
            />
            <ParagraphTag
              content={formatCurrency(retryAmount)}
              classes="text-darkColor font-popinsSemiBold text-sm"
            />
          </div>
          <div className="flex justify-between">
            <ParagraphTag
              content="Purpose"
              classes="text-darkColor/60 font-popinsMedium text-sm"
            />
            <ParagraphTag
              content={transaction?.purpose || "Scheduled Rent"}
              classes="text-darkColor font-popinsSemiBold text-sm"
            />
          </div>
          <div className="flex justify-between">
            <ParagraphTag
              content="Month"
              classes="text-darkColor/60 font-popinsMedium text-sm"
            />
            <ParagraphTag
              content={getMonthLabel(transaction?.createdAt)}
              classes="text-darkColor font-popinsSemiBold text-sm"
            />
          </div>
        </div>

        <div className="flex gap-3">
          {loading ? (
            <div className="flex justify-center items-center w-full">
              <MyLoader />
            </div>
          ) : (
            <>
              <button
                onClick={onClose}
                className="flex-1 py-2 rounded-lg border-2 border-gray-300 text-gray-600 font-popinsMedium text-sm hover:bg-gray-50 transition-colors"
              >
                Cancel
              </button>
              <ButtonTag
                name="Yes, Retry"
                onSubmit={onConfirm}
                classes="flex-1 text-sm text-center bg-themeColor text-white"
              />
            </>
          )}
        </div>
      </section>
    </main>
  );
};

export default RetryTransactionPopUp;
